import React from "react";
import NimbusLinkCard from "../../../ui-components/nimbus-link-card/nimbus-link-card";

const NimbusOrganisationsIndex = () => {
  return (
    <div className="flex flex-wrap h-full text-center gap-2 pt-20">
      <NimbusLinkCard
        title={"New Organisation"}
        to={"/nimbus/organisations/new"}
        icon="fa-seedling"
      />

      <NimbusLinkCard
        to={"/nimbus/organisations/search"}
        icon={"fa-magnifying-glass"}
        title="Search Organisations"
      />
      <NimbusLinkCard
        to={"/nimbus/organisation_user/search"}
        icon={"fa-person"}
        title="Search Organisation Users"
      />

      <NimbusLinkCard
        to={"/nimbus/sharecards/new"}
        icon={"fa-square-share-nodes"}
        title="New Sharecard"
      />
    </div>
  );
};

export default NimbusOrganisationsIndex;
